/**
 * Feature flags.
 *
 * AI_ASSISTANT_ENABLED — turned OFF 2026-09-08 at the user's request ("i want to
 * disable the AI agent within tricorps 360 until i have time to work on it
 * more"). Flipping this back to true restores the floating chat widget, the
 * sidebar item and the /ai-assistant route. The backend has its own switch,
 * AI_ASSISTANT_ENABLED in backend/.env, which must be set to true as well —
 * two switches on purpose, so a stale build cannot start spending on the LLM.
 */
export const AI_ASSISTANT_ENABLED = false;
